import React, { memo } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { CONTEXT } from '../../config';
import styles from './Nav.module.less';
import { logging, logPostInfo } from '../../actions/log';

const tabs = [
  {
    text: '精选',
    name: 'CareChioce',
    icon: 'icon-recommend1_15',
    url: 'wprecommend',
  },
  {
    text: '分类',
    name: 'wpcategory',
    icon: 'icon-category1_15',
    url: 'wpcategory',
  },
  {
    text: '我的壁纸',
    name: 'wpmine',
    icon: 'icon-menu_wallpaper',
    url: 'wpmine/setup',
  },
];

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ active = 'CareChioce' }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const handleClick = e => {
    if (e.target && e.target.hasAttribute('data-url')) {
      const target = e.target.getAttribute('data-url');
      const targetObj = tabs.find(item => item.url === target);
      if (targetObj && targetObj.name !== active) {
        history.push(`${CONTEXT}/${e.target.getAttribute('data-url')}`);
      }
    }

    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Menu',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          menuType: e.target.getAttribute('data-url'),
        },
      }),
    );

    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
  };
  return (
    <div className={styles.nav_box}>
      <div className={styles.nav} onClick={handleClick}>
        {tabs.map(item => (
          <div
            className={classNames(styles.item, { [styles.active]: active === item.name })}
            key={item.name}
            data-url={item.url}
          >
            <i
              data-url={item.url}
              className={classNames('iconfont', item.icon, styles.icon, {
                [styles.active_icon]: active === item.name,
              })}
            />
            <div className={styles.nav_text} data-url={item.url}>
              {item.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
